import { memo } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { SortableColumnHeader } from '@/components/insurance/SortableColumnHeader';
import type { IPolicyTableHeaderProps } from '@/@types/insurance';

export const PolicyTableHeader = memo(function PolicyTableHeader({
  sortState,
  onToggleSort,
  isAllSelected,
  isSomeSelected,
  onSelectAllChange,
  visibleColumns,
}: IPolicyTableHeaderProps) {
  return (
    <div className="flex items-center h-11 px-6 bg-table-header border-b border-table-row-border min-w-max">
      <div className="w-[48px] shrink-0 pr-2 flex items-center sticky left-0 bg-table-header z-10">
        <Checkbox
          checked={isAllSelected ? true : isSomeSelected ? 'indeterminate' : false}
          onCheckedChange={checked => onSelectAllChange(checked === true)}
          aria-label="Select all policies"
        />
      </div>
      {visibleColumns.map(col => (
        <div key={col.id} className={`${col.width ?? 'w-[120px]'} shrink-0 pr-3`}>
          <SortableColumnHeader column={col} sortState={sortState} onToggleSort={onToggleSort} />
        </div>
      ))}
    </div>
  );
});
